import {
  FETCH_POSITIONS_LIST,
  FETCH_POSITIONS_LIST_ERROR,
  FETCH_POSITIONS_LIST_SUCCESS,
  FETCH_IRC_JUSTIFICATIONS_REQUEST,
  FETCH_IRC_JUSTIFICATIONS_SUCCESS,
  FETCH_IRC_JUSTIFICATIONS_ERROR,
  SAVE_IRC_JUSTIFICATION_REQUEST,
  SAVE_IRC_JUSTIFICATION_SUCCESS,
  SAVE_IRC_JUSTIFICATION_ERROR,
  SAVE_ALL_IRC_JUSTIFICATION_REQUEST,
  SAVE_ALL_IRC_JUSTIFICATION_SUCCESS,
  SAVE_ALL_IRC_JUSTIFICATION_ERROR,
  UPDATE_IRC_JUSTIFICATION_REQUEST,
  UPDATE_IRC_JUSTIFICATION_SUCCESS,
  UPDATE_IRC_JUSTIFICATION_ERROR,
  DELETE_IRC_JUSTIFICATION_REQUEST,
  DELETE_IRC_JUSTIFICATION_SUCCESS,
  DELETE_IRC_JUSTIFICATION_ERROR
} from 'actionTypes'

const DEFAULT_STATE = {
  list: {
    records: [],
    error: null,
    isFetching: false,
    current: null,
    pages: null,
    count: null,
  },
  save: {
    record: {},
    error: null,
    isFetching: false,
  },
  productsValidation: {
    error: null,
    validated: {},
  },
}

const reducer = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case FETCH_POSITIONS_LIST:
      return {
        ...state,
        list: {
          ...state.list,
          isFetching: true,
        },
      }

    case FETCH_POSITIONS_LIST_SUCCESS:
      return {
        ...state,
        list: {
          ...state.list,
          isFetching: false,
          error: null,
          records: action.payload,
        },
        productsValidation: {
          error: null,
          validated: {},
        },
      }

    case FETCH_POSITIONS_LIST_ERROR:
      return {
        ...state,
        list: {
          ...state.list,
          isFetching: false,
          error: action.payload,
        },
      }
    
    case FETCH_IRC_JUSTIFICATIONS_REQUEST:
      return {
        ...state,
        list: {
          ...state.list,
          isFetching: true,
        },
      }

    case FETCH_IRC_JUSTIFICATIONS_SUCCESS:
      return {
        ...state,
        list: {
          ...state.list,
          isFetching: false,
          error: null,
          records: action.payload,
          current: action.payload.number,  
          pages: action.payload.totalPages, 
          count: action.payload.totalElements,
        },
      }

    case FETCH_IRC_JUSTIFICATIONS_ERROR:
      return {
        ...state,
        list: {
          ...state.list,
          isFetching: false,
          error: action.payload,
        },
      }
      
    case SAVE_IRC_JUSTIFICATION_REQUEST:
        return {
          ...state,
          list: {
            ...state.list,
            isFetching: true,
          },
        }
  
    case SAVE_IRC_JUSTIFICATION_SUCCESS:
      return {
        ...state,
        list: {
          ...state.list,
          isFetching: false,
          error: null,
          records: action.payload,
          current: action.payload.number,  
          pages: action.payload.totalPages, 
          count: action.payload.totalElements,
        },
      }
  
    case SAVE_IRC_JUSTIFICATION_ERROR:
      return {
        ...state,
        list: {
          ...state.list,
          isFetching: false,
          error: action.payload,
        },
      }
    
      case SAVE_ALL_IRC_JUSTIFICATION_REQUEST:
      return {
        ...state,
        list: {
          ...state.list,
          isFetching: true,
        },
      }

    case SAVE_ALL_IRC_JUSTIFICATION_SUCCESS:
      return {
        ...state,
        list: {
          ...state.list,
          isFetching: false,
          error: null,
          records: action.payload,
          current: action.payload.number,  
          pages: action.payload.totalPages, 
          count: action.payload.totalElements,
        },
      }

    case SAVE_ALL_IRC_JUSTIFICATION_ERROR:
      return {
        ...state,
        list: {
          ...state.list,
          isFetching: false,
          error: action.payload,
        },
      }
      
    case UPDATE_IRC_JUSTIFICATION_REQUEST:
      return {
        ...state,
        list: {
          ...state.list,
          isFetching: true,
        },
      }

    case UPDATE_IRC_JUSTIFICATION_SUCCESS:
      return {
        ...state,
        list: {
          ...state.list,
          isFetching: false,
          error: null,
          records: action.payload,
          current: action.payload.number,  
          pages: action.payload.totalPages, 
          count: action.payload.totalElements,
        },
      }

    case UPDATE_IRC_JUSTIFICATION_ERROR:
      return {
        ...state,
        list: {
          ...state.list,
          isFetching: false,
          error: action.payload,
        },
      }
  
    case DELETE_IRC_JUSTIFICATION_REQUEST:
      return {
        ...state,
        list: {
          ...state.list,
          isFetching: true,
        },
      }

    case DELETE_IRC_JUSTIFICATION_SUCCESS:
      return {
        ...state,
        list: {
          ...state.list,
          isFetching: false,
          error: null,
          records: action.payload,
          current: action.payload.number,  
          pages: action.payload.totalPages, 
          count: action.payload.totalElements,
        },
      }

    case DELETE_IRC_JUSTIFICATION_ERROR:
      return {
        ...state,
        list: {
          ...state.list,
          isFetching: false,
          error: action.payload,
        },
      }

    default:
      return state
  }
}

export default reducer
